import React from 'react';
import { EnquiryBasketStyles as S } from './EnquiryBasket.styles';
import { Grid } from '@helpers/grid';
import withWidget from '@hoc/withWidget';
import withRedux from '@helpers/withRedux';
import { HydrateOption } from '@core/enums';
import { useDispatch, useSelector } from 'react-redux';
import { imageUrl } from '@helpers/imageUrl';
import { ReactComponent as Close } from '@img/icons/close.svg';
import { useForm } from 'react-hook-form';
import { LoginModalStyles as FormStyles } from '../Forms/LoginModal/LoginModal.styles';
import Button from '@stories/Components/Buttons/Button/Button';
import ApiService from '@core/api/services/ApiService';
import { ThemeWrapper } from '@helpers/theme';
const EnquiryBasket = ({ translations, siteId, theme }) => {
    const dispatch = useDispatch();
    const enquiryItems = useSelector((x) => x.basket.enquiryBasket?.enquiries);
    const basketItems = useSelector((x) => x.basket.basket?.order?.orderLines);
    const [showSuccessMessage, setShowSuccessMessage] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const ref = React.useRef(null);
    const [hasOverflow, setHasOverflow] = React.useState(false);
    const showBasketMessage = React.useMemo(() => siteId === 1 && basketItems && basketItems.length > 0, [basketItems]);
    React.useEffect(() => {
        if (ref.current) {
            setHasOverflow(ref.current.scrollHeight > ref.current.clientHeight);
        }
    }, [ref]);
    const { register, handleSubmit, formState: { errors }, setError, clearErrors, } = useForm();
    const remove = async (id) => {
        setIsLoading(true);
        try {
            const response = await ApiService.request({
                method: 'DELETE',
                slug: 'remove',
                controller: 'customer-enquiry',
                params: {
                    enquiries: enquiryItems,
                    productId: id,
                },
            });
            if (response.status.success) {
                dispatch({
                    type: 'BASKET/SET_ENQUIRY_BASKET',
                    payload: response.result,
                });
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    const submit = async (state) => {
        setIsLoading(true);
        try {
            const response = await ApiService.request({
                method: 'POST',
                slug: 'submit',
                controller: 'customer-enquiry',
                params: {
                    ...state,
                    customerEnquiries: enquiryItems,
                    siteId,
                },
            });
            if (response.status.success) {
                setShowSuccessMessage(true);
                clearErrors();
                dispatch({
                    type: 'BASKET/SET_ENQUIRY_BASKET',
                    payload: response.result,
                });
            }
            else {
                if (response.validationErrors) {
                    response.validationErrors.forEach((error) => setError(error.errorSourceId, { message: error.message }));
                }
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    return (React.createElement(ThemeWrapper, { "data-theme": theme },
        React.createElement(Grid.Default, null,
            !showSuccessMessage &&
                basketItems &&
                showBasketMessage &&
                translations['custom.gf.enquiryBasket.basketMessage'] && (React.createElement(S.BasketMessage, null,
                React.createElement(S.BasketMessageTitle, { size: "large" }, translations['custom.gf.enquiryBasket.basketMessage.title']),
                React.createElement(S.BasketMessageInner, { dangerouslySetInnerHTML: {
                        __html: translations['custom.gf.enquiryBasket.basketMessage']
                            .replace(/\[.+\]/g, `${basketItems.length}`)
                            .replace(/\{(.+)\}/g, `<a href="${translations['custom.gf.enquiryBasket.basketMessage.url']}">$1</a>`),
                    } }))),
            React.createElement(S.Container, null,
                React.createElement(S.TopSection, null,
                    React.createElement(S.Title, { semantic: "h1", visual: "h1" }, translations['custom.gf.enquiryBasket.title']),
                    !showSuccessMessage && (React.createElement(S.Subtitle, { size: "regular" }, translations['custom.gf.enquiryBasket.subtitle']))),
                showSuccessMessage ? (React.createElement(S.Split, null,
                    React.createElement(S.SuccessMessage, { size: "regular" }, translations['custom.gf.enquiryBasket.successMessage']))) : (React.createElement(S.Split, null,
                    React.createElement(S.LeftSection, null,
                        React.createElement(S.SelectedProductsText, { size: "regular" }, !enquiryItems || (enquiryItems && enquiryItems.length === 0)
                            ? translations['custom.gf.enquiryBasket.noSelectedProducts']
                            : translations['custom.gf.enquiryBasket.selectedProducts']),
                        enquiryItems && enquiryItems.length > 0 && (React.createElement("div", null,
                            React.createElement(S.ProductsList, { "data-has-overflow": hasOverflow, ref: ref }, enquiryItems.map((product, i) => (React.createElement(S.ProductCard, { key: `EnquiryBasket_ProductCard_${i}` },
                                React.createElement("img", { src: imageUrl(product.image, { width: 222, crop: 'mfit' }) }),
                                React.createElement("span", null, product.title),
                                React.createElement(S.RemoveButton, { "data-disabled": isLoading, onClick: (e) => (isLoading ? e.preventDefault() : remove(product.id)) },
                                    React.createElement(Close, null))))))))),
                    React.createElement(S.GreenShape, null),
                    React.createElement(S.FormWrapper, null,
                        errors.customerEnquiries?.message && (React.createElement(FormStyles.Error, null, errors.customerEnquiries.message)),
                        React.createElement(S.FormRow, null,
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null,
                                    translations['custom.gf.enquiryBasket.fullName'],
                                    "*"),
                                React.createElement(FormStyles.Input, { required: true, placeholder: translations['custom.gf.enquiryBasket.fullName.placeholder'], ...register('fullName', {
                                        required: translations['custom.gf.enquiryBasket.fullName.required'],
                                    }) }),
                                errors.fullName?.message && (React.createElement(FormStyles.Error, null, errors.fullName.message))),
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null, translations['custom.gf.enquiryBasket.phoneNumber']),
                                React.createElement(FormStyles.Input, { placeholder: translations['custom.gf.enquiryBasket.phoneNumber.placeholder'], ...register('phoneNumber') }))),
                        React.createElement(S.FormRow, null,
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null,
                                    translations['custom.gf.enquiryBasket.email'],
                                    "*"),
                                React.createElement(FormStyles.Input, { required: true, placeholder: translations['custom.gf.enquiryBasket.email.placeholder'], ...register('emailAddress', {
                                        required: translations['custom.gf.enquiryBasket.email.required'],
                                    }) }),
                                errors.emailAddress?.message && (React.createElement(FormStyles.Error, null, errors.emailAddress.message))),
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null,
                                    translations['custom.gf.enquiryBasket.sitePostcode'],
                                    "*"),
                                React.createElement(FormStyles.Input, { required: true, placeholder: translations['custom.gf.enquiryBasket.sitePostcode.placeholder'], ...register('sitePostcode', {
                                        required: translations['custom.gf.enquiryBasket.sitePostcode.required'],
                                    }) }),
                                errors.sitePostcode?.message && (React.createElement(FormStyles.Error, null, errors.sitePostcode.message)))),
                        React.createElement(S.FormRow, { wide: true },
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null,
                                    translations['custom.gf.enquiryBasket.companyName'],
                                    "*"),
                                React.createElement(FormStyles.Input, { required: true, placeholder: translations['custom.gf.enquiryBasket.companyName.placeholder'], ...register('companyName', {
                                        required: translations['custom.gf.enquiryBasket.companyName.required'],
                                    }) }),
                                errors.companyName?.message && (React.createElement(FormStyles.Error, null, errors.companyName.message)))),
                        React.createElement(S.FormRow, { wide: true },
                            React.createElement(FormStyles.Field, null,
                                React.createElement(FormStyles.Label, null, translations['custom.gf.enquiryBasket.additionalInformation']),
                                React.createElement(FormStyles.TextArea, { placeholder: translations['custom.gf.enquiryBasket.additionalInformation.placeholder'], ...register('additionalInformation') }))),
                        React.createElement(Button, { disabled: isLoading, branding: "secondary", title: translations['custom.gf.enquiryBasket.submit'], onClick: (ev) => handleSubmit(submit)(ev) }))))))));
};
export default withWidget(withRedux(EnquiryBasket), 'EnquiryBasket', {
    hydrate: HydrateOption.InView,
});
